import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import TranslateButton from "../../TranslateButton/TranslateButton";
import "../../../style/jobCircular/jobCircularDYD.css";
import CircularOne from "../../../images/Job Circular/Circular_Request for DYD_1.jpg";
import CircularTwo from "../../../images/Job Circular/Circular_Request for DYD_2.jpg";
import CircularThree from "../../../images/Job Circular/Circular_Request for DYD_3.jpg";
import CircularFour from "../../../images/Job Circular/Circular_Request for DYD_4.jpg";
import CircularFive from "../../../images/Job Circular/Circular_Request for DYD_5.jpg";
import CircularSix from "../../../images/Job Circular/Circular_Request for DYD_6.jpg";
import CircularSeven from "../../../images/Job Circular/Circular_Request for DYD_7.jpg";
import CircularEight from "../../../images/Job Circular/Circular_Request for DYD_8.jpg";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const JobCircularDYD = () => {
  useEffect(() => {
    document.title = `AshroyAngon | We Are Hiring DYD`;
  }, []);

  const shareUrl = "https://ashroyangon.org/we-are-hiring/earn-project";

  return (
    <>
      <Navbar />
      <TranslateButton />

      <div className="earn_project_section">
        {/* Header Background Part Start */}
        <div className="header_background">
          <div className="container wrapper">
            <h2>We Are Hiring</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div>
        {/* Header Background Part End */}

        <div className="earn_project_wrapper">
          <div className="container">
            <h2>We Are Hiring</h2>
            <img src={CircularOne} loading="lazy" alt="" />
            <img src={CircularTwo} loading="lazy" alt="" />
            <img src={CircularThree} loading="lazy" alt="" />
            <img src={CircularFour} loading="lazy" alt="" />
            <img src={CircularFive} loading="lazy" alt="" />
            <img src={CircularSix} loading="lazy" alt="" />
            <img src={CircularSeven} loading="lazy" alt="" />
            <img src={CircularEight} loading="lazy" alt="" />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default JobCircularDYD;
